export const parseQueryParams = (url: string): Record<string, string> => {
  const result: Record<string, string> = {};
  try {
    const search = new URL(url).search;
    if (search === '') return result;
    const params = new URLSearchParams(search);
    params.forEach((value, key) => {
      result[key] = value;
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Ошибка при разборе URL:', e);
  }
  return result;
};
